/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'cross-flow-support.back-to-all-products': '返回所有應用程式',
  'cross-flow-support.close': '關閉',
};
